<template>
	<div class="set-password">
		<div class="page-container">
			<h1 class="set-password__title">Set your account password</h1>
			<form class="form set-password__container" v-on:submit="resetPassword">
				<div class="form__message form__message--error" v-if="tokenExpired">
					Sorry, this request has expired. For security reasons, please <router-link :to="{ name: 'ResetPassword'}" class="link--underlined link--wrap">request a new password here</router-link>.
				</div>
				<text-field class="set-password__password" label="Password" type="password" name="password" placeholder="******" v-model="password" />
				<text-field class="set-password__confirm-password" label="Confirm Password" type="password" name="confirm-password" placeholder="******" v-model="confirmPassword" />
				<submit-field class="set-password__submit">
					<span>Update Password</span>
				</submit-field>
			</form>
		</div>
	</div>
</template>

<script>
import TextField from '../atoms/TextField'
import SubmitField from '../atoms/SubmitField'

export default {
	name: 'SetPassword',
	components: {
		TextField,
		SubmitField,
	},
	data () {
		return {
			token: null,
			password: '',
			confirmPassword: '',
			tokenExpired: false
		}
	},
	created: function ()
	{
		var self = this;

		if(self.$route.params.hasOwnProperty('token'))
		{
			self.token = self.$route.params.token;
			self.$root.$data.appLoading = false;
		}
		else
		{
			self.$router.push({name: 'Login'});
		}
	},
	methods: {
		resetPassword(event)
		{
			var self = this;
			event.preventDefault();

			if(self.password !== self.confirmPassword)
			{
				self.$alert.danger({ message: 'Passwords must match' });
				return;
			}

			self.$api.updatePassword(self.token, self.password).then((success) => {
				self.$alert.success({ message: "Password reset successfully. Redirecting..." });
				setTimeout(function()
				{
					self.$router.push({name: 'Login'});
				}, 3000);
			}).catch((error) => {

				if(error.message === "Token provided is invalid.")
				{
					self.tokenExpired = true;
				}
				else
				{
					self.$alert.danger({ message: error.message });
				}
			});
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

	@import "src/scss/toolkit";

	$c: ".set-password";
	#{$c}
	{
		background-color: #F4F4F4;
		padding: { top: rem(192); bottom: rem(160); }
		text-align: center;

		&__container
		{
			max-width: 416px;
			@include extend(block-center);
			@include extend(bgc-pal--white);
			border: 1px solid palette('divider');
			padding: rem(48) rem(36);
			text-align: left;
		}

		&__title
		{
			@include extend(h3);
			margin-bottom: rem(48);
		}

		&__password
		{
			margin-bottom: rem(24);
		}

		&__confirm-password
		{
			margin-bottom: rem(48);
		}

		&__submit
		{
			text-align: center;

			.field__element
			{
				width: 100%;
				max-width: 216px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/admin/SetPassword.vue